import React from 'react';

import styles from './MultipleDynamic.module.css';
import QuestionInterface from '../../../interfaces/question';
import Question from '../Question/Question';

export interface MultipleDynamicProps {
  questions: QuestionInterface[];
}

const MultipleDynamic: React.FunctionComponent<MultipleDynamicProps> = ({ questions }) => (
  <div className={styles.multipleDynamicContainer}>
    {questions.map((q) => (
      <Question question={q} key={`dynamic-${q.id}`} />
    ))}
  </div>
);

MultipleDynamic.displayName = 'MultipleDynamic';

export default MultipleDynamic;
